<div class="decoration"></div>
<app-env-badge></app-env-badge>
<div class="content">
  <div class="cols">
    <div class="main">
      <div class="spacer"></div>
      <div class="center">
        <router-outlet></router-outlet>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
</div>
